import { user } from '../../core/selectors.js';
import { render } from '../../core/shell.js';
import { S, UI, save } from '../../core/store.js';
import { toast } from '../../core/ui.js';
import { $, off } from '../../core/util.js';
import { audit } from '../../core/activity.js';

export const actions={
btab(el){UI.btab=el.dataset.t;if(UI.btab==='contracts')audit('opened Contracts');save();render()},
ctup(el){UI.ctId=el.dataset.id;$('#fc').click()},
driveall(){Object.values(S.hr).forEach(h=>{if(h.contract)h.contract.drive=1});audit('backed up all contracts to Google Drive');save();render();toast('All contracts copied to the locked Drive folder (demo)')}
};

export const changes={
hrrate(el){S.hr[el.dataset.id].rate=Number(el.value)||0;audit('changed a pay rate');save();render()},
hrhrs(el){S.hr[el.dataset.id].hrs=Number(el.value)||0;save();render()},
hrdays(el){S.hr[el.dataset.id].days=Number(el.value)||0;save();render()},
ctfile(el){const f=el.files[0];if(!f)return;S.hr[UI.ctId].contract={file:f.name,signed:off(0),drive:0};audit('uploaded a contract for '+user(UI.ctId).name);save();render();toast('Uploaded. Next backup to Drive copies it across');el.value=''}
};
